import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as EconomicSectorService from '@/services/economic-sector.service';

@Options({
  name: 'economic-sector-new',
  components: {
    Toggle,
  },
})
export default class EconomicSectorNew extends Vue {
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row = {
    description: '',
    enabled: true,
  };

  public goBack() {
    this.$router.push('/economic-sector');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      EconomicSectorService.insert({
        description: this.row.description,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/economic-sector');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
